import React from 'react';
import { Layout } from '../../../../components/core';
import { SurveyCard } from './SurveyCard';
import { SurveyNoActiveFeedback } from './SurveyNoActiveFeedback';

export type CompletedNoActiveSurveyProps = {
  name: string;
  onViewResults: () => void;
};

export const CompletedNoActiveSurvey = ({
  name,
  onViewResults,
}: CompletedNoActiveSurveyProps): JSX.Element => (
  <Layout.VStack space={4}>
    <SurveyNoActiveFeedback />
    <SurveyCard
      title={name}
      status="completed"
      onActionPress={onViewResults}
      actionLabel="View Results"
      actionTestId="pressable-survey-view-results"
      actionVariant="secondary"
      ariaLabel="View survey results"
    />
  </Layout.VStack>
);
